"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatFileDropOverlay = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _card = require("@design/ui/card");
var _empty = require("@design/ui/empty");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ChatFileDropOverlay = exports.ChatFileDropOverlay = function ChatFileDropOverlay(_ref) {
  var isVisible = _ref.isVisible;
  if (!isVisible) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": "chat-file-drop-overlay",
    className: "absolute inset-0 z-40 flex items-center justify-center bg-overlay",
    "data-sentry-component": "ChatFileDropOverlay",
    "data-sentry-source-file": "ChatFileDropOverlay.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.Card, {
      className: "pointer-events-none",
      "data-sentry-element": "Card",
      "data-sentry-source-file": "ChatFileDropOverlay.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_empty.Empty, {
        "data-sentry-element": "Empty",
        "data-sentry-source-file": "ChatFileDropOverlay.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_empty.EmptyHeader, {
          "data-sentry-element": "EmptyHeader",
          "data-sentry-source-file": "ChatFileDropOverlay.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_empty.EmptyMedia, {
            variant: "icon",
            "data-sentry-element": "EmptyMedia",
            "data-sentry-source-file": "ChatFileDropOverlay.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.AttachFileIcon, {
              "data-sentry-element": "AttachFileIcon",
              "data-sentry-source-file": "ChatFileDropOverlay.tsx"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_empty.EmptyTitle, {
            "data-sentry-element": "EmptyTitle",
            "data-sentry-source-file": "ChatFileDropOverlay.tsx",
            children: "Add documents"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_empty.EmptyDescription, {
            "data-sentry-element": "EmptyDescription",
            "data-sentry-source-file": "ChatFileDropOverlay.tsx",
            children: "Drop any file here to add it to the conversation"
          })]
        })
      })
    })
  });
};